import VisualizationPlaceholder from './VisualizationPlaceholder';

export default VisualizationPlaceholder;
